module.exports = __webpack_public_path__ + "img/icon-ana-vendor.0068e1cc.png";